import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

const RmrNetworkMerchant_ = z.object({
  teamId: z.string(),
  name: z.string(),
  accountId: z.string().nullable(),
  onboardedAt: z.date().nullable(),
  firstReturnAt: z.date().nullable(),
  returnsCenterIds: z.array(z.string()),
});
export const RmrNetworkMerchant: z.ZodType<RmrNetworkMerchant> =
  RmrNetworkMerchant_;
export interface RmrNetworkMerchant
  extends z.infer<typeof RmrNetworkMerchant_> {}

const RmrNetworkSummary_ = z.object({
  merchants: z.array(RmrNetworkMerchant),
  merchantsEnabledCount: z.number(),
  totalItemsInNetwork: z.number(),
  shippableItems: z.number(),
  totalValueCents: z.number(),
});
export const RmrNetworkSummary: z.ZodType<RmrNetworkSummary> =
  RmrNetworkSummary_;
export interface RmrNetworkSummary extends z.infer<typeof RmrNetworkSummary_> {}

export const getRmrNetworkSummary = unaryRpc({
  name: "getRmrNetworkSummary" as const,
  input: z.object({}),
  output: RmrNetworkSummary,
});
